<script setup>
import { useNavigation } from "@/app/composables/useNavigation";
import { SITE_LABELS } from "@/content/site";
import HeroSection from "@/app/components/sections/HeroSection.vue";
import TherapistsSection from "@/app/components/sections/TherapistsSection.vue";
import ServicesSection from "@/app/components/sections/ServicesSection.vue";
import ContactSection from "@/app/components/sections/ContactSection.vue";
import FooterSection from "@/app/components/sections/FooterSection.vue";
import PracticeRoomsSection from "@/app/components/sections/PracticeRoomsSection.vue";

const { navigateHome } = useNavigation();
</script>

<template>
  <div class="centering-flex-container fill-height">
    <!-- Back button integrated into hero -->
    <div class="back-button-container">
      <button class="back-btn" @click="navigateHome">
        {{ SITE_LABELS.backButtonLabel }}
      </button>
    </div>

    <HeroSection />
    <ServicesSection no-box/>
    <PracticeRoomsSection no-box/>
    <TherapistsSection no-box/>
    <ContactSection no-box/>
    <FooterSection />
  </div>
</template>

<style scoped>
/* Back button styles are now in Global.css */
</style>
